import { atom } from 'jotai';

interface ILoadArticleRelatedPostsValue {
  loader?: () => void;
}

export const $LoadArticleRelatedPosts = atom<ILoadArticleRelatedPostsValue>({});
